var shim = { exports: {} };
export {
  shim as __module
};
//# sourceMappingURL=index.mjs.map
